<div class="mobile-logo" [class.blue-full]="logo() === 'blue-full'" [class.white-full]="logo() === 'white-full'"
	[class.white-small]="logo() === 'white-small'">
</div>